import _ from 'lodash'
import moment from 'moment'
const discovery = (state = {
  bounds: {},
  hotelId: null,
  isLoading: true,
  isPrimed: false,
  nights: 0,
  packagesCount: 0,
  partyComp: { adults: 2, childAges: [] },
  startDate: null,
  venueCode: null,
  venueName: null
}, action) => {
  switch (action.type) {
    case 'DISCOVERY_PRIMED': {
      return Object.assign({}, state, {
        isPrimed: action.primed
      })
    }
    case 'DISCOVERY_CALENDAR_UPDATE': {
      return Object.assign({}, state, {
        nights: action.nights,
        packagesCount: action.packagesCount,
        bounds: action.bounds,
        isLoading: action.isLoading
      })
    }
    case 'DISCOVERY_CALENDAR_SELECT_DAY': {
      const { pathname, searchParams } = action.day
      if (pathname && searchParams && state.hotelId) {
        window.location = `https://${window.location.host}/${pathname}?${searchParams}${`#${state.hotelId}`}`
        break
      }
      // When looking for availability without a hotel id
      window.location = `https://${window.location.host}/${pathname}?${searchParams}&sortBy=grossPriceInPence`
      break
    }
    case 'DISCOVERY_CALENDAR': {
      const { roomRates = {}, venueCode, searchFormId } = _.get(window, 'packageRatesReply.meta.context', {})
      const { rooms = [], checkinDate, checkoutDate } = roomRates
      const { venueProducts = {} } = _.get(window, 'packageRatesReply.linked', {})
      const name = (Object.values(venueProducts)[0] && Object.values(venueProducts)[0].name) || ''
      const nights = moment(checkoutDate).diff(checkinDate, 'days')
      const partyComp = rooms.reduce((partyComp, room) => {
        partyComp.adults += room.adults
        partyComp.childAges = partyComp.childAges.concat(room.childrenAges, room.infantsAges)
        return partyComp
      }, { adults: 0, childAges: [] })
      return Object.assign({}, state, {
        hasEventEntry: action.hasParkEntry,
        hotelId: action.hotelId,
        isLoading: true,
        nights,
        partyComp,
        searchFormId,
        startDate: checkinDate,
        venueCode,
        venueName: name
      })
    }
  }
  return state
}

export default discovery
